module.exports = __webpack_public_path__ + "images/emoji/three.1b88681d767d15ae6039.png";